/* rift-core.js
   THE BLACK RIFT: the shared browser bits. It only animates what the server already decided.
   - counts down every [data-rf-count] (a unix time in seconds), using the server's own clock
     (data-rf-now) so a wrong phone clock does not matter
   - fills every [data-rf-xp] progress bar
   - hides the beacon when it is dismissed (until the next gate opens)
   - the raid timer bar on the LORGAR page (data-rf-hp): how much of the raid is left, from the same clock
   - "Remind me": a calendar file and a Google Calendar link for the moment a gate opens, made on the visitor's own
     device from the date the page prints. Nothing is sent or stored.
   - "Invite your party": the phone's share sheet, or a copied link (tagged utm_source=party)
   - sections fade in once as they scroll into view (only below the fold, never for reduced motion, can be switched off)
   - when a countdown that asked for it (data-rf-reload) hits zero, loads the page fresh once,
     with a small random delay so a midnight crowd does not hit the store in the same second
   Nothing here decides which gates are open or reveals anything. */
(function () {
  'use strict';
  /* Loaded once from layout/theme.liquid. If another tag ever loads it again, do nothing twice. */
  if (window.RiftCore) return;
  if (window.__rfCore) return;
  window.__rfCore = true;

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var skew = 0, simulated = false;
  var first = document.querySelector('[data-rf-now]');
  if (first) {
    var sn = parseInt(first.getAttribute('data-rf-now'), 10);
    if (sn > 0) skew = sn * 1000 - Date.now();
    simulated = first.getAttribute('data-rf-sim') === 'yes';
  }
  function now() { return Date.now() + skew; }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function fmt(ms) {
    if (ms <= 0) return '00:00:00';
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    if (d > 0) return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';
    return pad(h) + ':' + pad(m) + ':' + pad(x);
  }

  function reloadOnce(target) {
    if (simulated) return;
    var key = 'rf-reload-' + target;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) { return; }
    var wait = 1500 + Math.random() * 4500;
    setTimeout(function () {
      var u = new URL(location.href);
      u.searchParams.set('rf', String(Math.floor(Date.now() / 1000)));
      location.replace(u.toString());
    }, wait);
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-rf-count]');
    var t = now();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i], target = parseInt(el.getAttribute('data-rf-count'), 10);
      if (!target) continue;
      var left = target * 1000 - t;
      var txt = fmt(left);
      if (el.textContent !== txt) el.textContent = txt;
      if (left <= 0 && el.hasAttribute('data-rf-reload')) { el.removeAttribute('data-rf-reload'); reloadOnce(target); }
      if (el.hasAttribute('data-rf-label')) el.setAttribute('aria-label', fmt(left));
    }
    var clocks = document.querySelectorAll('[data-rf-clock]');
    for (var c = 0; c < clocks.length; c++) {
      var ck = clocks[c], ct = parseInt(ck.getAttribute('data-rf-clock'), 10);
      if (!ct) continue;
      var cl = Math.max(0, Math.floor((ct * 1000 - t) / 1000));
      var parts = { d: Math.floor(cl / 86400), h: Math.floor((cl % 86400) / 3600), m: Math.floor((cl % 3600) / 60), s: cl % 60 };
      var segs = ck.querySelectorAll('[data-u]');
      for (var k = 0; k < segs.length; k++) {
        var u = segs[k].getAttribute('data-u'), v = parts[u];
        var out = u === 'd' ? String(v) : pad(v);
        if (segs[k].textContent !== out) segs[k].textContent = out;
      }
      /* The digits are hidden from screen readers (they change every second), so the spoken label carries the time left, refreshed once a minute. */
      var mk = Math.floor(cl / 60);
      if (ck.__mk !== mk) {
        ck.__mk = mk;
        if (ck.__base === undefined) ck.__base = ck.getAttribute('aria-label') || '';
        var say = [];
        if (parts.d) say.push(parts.d + (parts.d === 1 ? ' day' : ' days'));
        if (parts.h) say.push(parts.h + (parts.h === 1 ? ' hour' : ' hours'));
        if (parts.m) say.push(parts.m + (parts.m === 1 ? ' minute' : ' minutes'));
        ck.setAttribute('aria-label', ck.__base + ' ' + (say.length ? say.join(', ') : 'less than a minute'));
      }
      if (cl <= 0 && ck.hasAttribute('data-rf-reload')) { ck.removeAttribute('data-rf-reload'); reloadOnce(ct); }
    }
    var hps = document.querySelectorAll('[data-rf-hp]');
    for (var q = 0; q < hps.length; q++) {
      var hp = hps[q], hf = parseInt(hp.getAttribute('data-rf-from'), 10), ht = parseInt(hp.getAttribute('data-rf-to'), 10);
      if (!hf || !ht || ht <= hf) continue;
      var hl = Math.floor(Math.max(0, Math.min(1, (ht - t / 1000) / (ht - hf))) * 100);
      if (hp.__p === hl) continue;
      hp.__p = hl;
      var fill = hp.querySelector('[data-rf-hp-fill]'), hv = hp.querySelector('[data-rf-hp-v]'), hb = hp.querySelector('[data-rf-hp-bar]');
      if (fill) fill.style.width = hl + '%';
      if (hv) hv.textContent = hl + '% of the raid left';
      if (hb) hb.setAttribute('aria-label', hl + ' percent of the raid time is left');
    }
    var bars = document.querySelectorAll('[data-rf-xp]');
    for (var j = 0; j < bars.length; j++) {
      var b = bars[j], from = parseInt(b.getAttribute('data-rf-from'), 10), to = parseInt(b.getAttribute('data-rf-to'), 10);
      if (!from || !to || to <= from) continue;
      var p = Math.max(0, Math.min(100, ((t / 1000 - from) / (to - from)) * 100));
      b.style.width = p.toFixed(2) + '%';
    }
  }

  /* ───────────── Remind me ───────────── */
  function stamp(sec) { var d = new Date(sec * 1000); return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + pad(d.getUTCSeconds()) + 'Z'; }
  function icsText(s) { return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
  function fold(line) { var out = []; while (line.length > 72) { out.push(line.slice(0, 72)); line = ' ' + line.slice(72); } out.push(line); return out.join('\r\n'); }
  function initRemind() {
    var rows = document.querySelectorAll('[data-rf-remind]');
    for (var i = 0; i < rows.length; i++) (function (row) {
      var ts = parseInt(row.getAttribute('data-ts'), 10);
      if (!ts || ts * 1000 <= now()) return;
      var title = row.getAttribute('data-title') || 'Brutech Black Rift', desc = row.getAttribute('data-desc') || '';
      var url = location.origin + location.pathname + (row.getAttribute('data-hash') || '');
      var start = stamp(ts), end = stamp(ts + 3600);
      var g = row.querySelector('[data-rf-gcal]'), b = row.querySelector('[data-rf-ics]'), ok = row.querySelector('[data-rf-remind-ok]');
      if (g) g.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) + '&dates=' + start + '/' + end + '&details=' + encodeURIComponent(desc + '\n\n' + url) + '&location=' + encodeURIComponent('brutech.co.za');
      if (b) b.addEventListener('click', function () {
        var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Brutech//Black Rift//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
          'UID:rift-' + ts + '@brutech.co.za', 'DTSTAMP:' + stamp(Math.floor(now() / 1000)), 'DTSTART:' + start, 'DTEND:' + end,
          'SUMMARY:' + icsText(title), 'DESCRIPTION:' + icsText(desc + ' ' + url), 'URL:' + url,
          'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:' + icsText(title), 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'];
        var text = lines.map(fold).join('\r\n') + '\r\n';
        try {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(new Blob([text], { type: 'text/calendar;charset=utf-8' }));
          a.download = 'brutech-black-rift-' + ts + '.ics';
          document.body.appendChild(a); a.click();
          setTimeout(function () { URL.revokeObjectURL(a.href); if (a.parentNode) a.parentNode.removeChild(a); }, 4000);
          if (ok) ok.textContent = 'Saved. Open the file to add it to your calendar.';
        } catch (e) { if (ok) ok.textContent = 'Could not make the file here. Try the Google Calendar link.'; }
      });
      row.hidden = false;
    })(rows[i]);
  }

  /* ───────────── Email me when it opens ─────────────
     The form is a normal Shopify customer form, so it works with no script at all. With script it sends in the
     background, tells Klaviyo who it is when Klaviyo is on the page, and swaps itself for a thank you. If Shopify asks
     for a captcha check (it answers with /challenge), the form is sent the normal way so the visitor can pass it. */
  function initNotify() {
    try {
      var forms = document.querySelectorAll('.rf-notify__form');
      if (!forms.length || typeof fetch !== 'function' || typeof FormData !== 'function') return;
      for (var i = 0; i < forms.length; i++) (function (form) {
        var wrap = form.closest ? form.closest('[data-rf-notify-wrap]') : form.parentNode;
        var ok = wrap ? wrap.querySelector('[data-rf-notify-ok]') : null;
        var btn = form.querySelector('button[type="submit"]');
        var mail = form.querySelector('input[type="email"]');
        var tagField = form.querySelector('input[name="contact[tags]"]');
        var busy = false;
        form.addEventListener('submit', function (e) {
          if (busy) { e.preventDefault(); return; }
          if (!mail || !mail.value || (mail.checkValidity && !mail.checkValidity())) return;
          e.preventDefault();
          busy = true;
          if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
          function finish(good) {
            busy = false;
            if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
            if (good) {
              form.hidden = true;
              if (ok) ok.textContent = 'You are on the list. We will email you when it opens.';
              try {
                if (window._learnq && window._learnq.push) {
                  var tags = tagField ? String(tagField.value).split(',') : [];
                  window._learnq.push(['identify', { '$email': mail.value, 'Black Rift gate': (tags[tags.length - 1] || '').replace(/^\s+|\s+$/g, '') }]);
                }
              } catch (er) {}
            } else if (ok) {
              ok.textContent = 'That did not go through. Check the address and try again.';
            }
          }
          fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
            .then(function (r) {
              if (r && r.url && r.url.indexOf('/challenge') > -1) { busy = false; form.submit(); return; }
              finish(!!(r && r.ok));
            })
            .catch(function () { finish(false); });
        });
      })(forms[i]);
    } catch (e) {}
  }

  /* ───────────── Invite your party ───────────── */
  function initShare() {
    var wraps = document.querySelectorAll('[data-rf-party]');
    var canShare = typeof navigator.share === 'function';
    var canCopy = !!(navigator.clipboard && navigator.clipboard.writeText);
    if (!wraps.length || (!canShare && !canCopy)) return;
    for (var i = 0; i < wraps.length; i++) (function (wrap) {
      var btn = wrap.querySelector('[data-rf-share]'), msg = wrap.querySelector('[data-rf-share-msg]');
      if (!btn) return;
      var timer = 0;
      function say(t) { if (!msg) return; msg.textContent = t; clearTimeout(timer); timer = setTimeout(function () { msg.textContent = ''; }, 4500); }
      function copy(url) {
        if (!canCopy) { say('Copy the address from your browser to share it.'); return; }
        navigator.clipboard.writeText(url).then(function () { say('Link copied. Paste it in your group chat.'); }, function () { say('Could not copy. Copy the address from your browser.'); });
      }
      btn.addEventListener('click', function () {
        var url = location.origin + location.pathname + '?utm_source=party&utm_medium=share&utm_campaign=black-rift';
        if (canShare) {
          navigator.share({ title: btn.getAttribute('data-title') || document.title, text: btn.getAttribute('data-text') || '', url: url }).catch(function (e) { if (e && e.name !== 'AbortError') copy(url); });
        } else copy(url);
      });
      wrap.hidden = false;
    })(wraps[i]);
  }

  /* ───────────── Sections fade in as they scroll into view ─────────────
     Only things that start below the fold get the class, so nothing is ever hidden on first sight, and a script
     failure leaves everything visible. Skipped for reduced motion, and by the theme setting. */
  var REVEAL = ['.rf-realm .rf-head', '.rf-realm .rf-journal', '.rf-realm .rf-stage', '.rf-realm .rf-chapters', '.rf-vault .rf-head', '.rf-vault .rf-tools', '.rf-vault .rf-deals > li',
    '.rf-faq .rf-trust__i', '.rf-faq .rf-head', '.rf-faq__list > *', '.rf-lg__rail .rf-head', '.rf-lg__loadout .rf-head', '.rf-lg__cat .rf-head', '.rf-lg__cat .rf-deals > li'].join(',');
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (document.querySelector('[data-fx-reveal="false"]')) return;
    var vh = window.innerHeight || 800;
    var els = Array.prototype.slice.call(document.querySelectorAll(REVEAL)).filter(function (el) {
      if (el.closest('[hidden]')) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.top > vh * 0.92;
    });
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      var vis = entries.filter(function (e) { return e.isIntersecting; }).sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left; });
      vis.forEach(function (e, i) {
        var el = e.target;
        el.style.transitionDelay = Math.min(i * 45, 270) + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
        setTimeout(function () { el.style.transitionDelay = ''; }, 900);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    els.forEach(function (el) { el.classList.add('rf-rv'); io.observe(el); });
  }

  function init() {
    tick();
    try { initRemind(); initShare(); initReveal(); } catch (e) {}
    initNotify();
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    window.addEventListener('pageshow', tick);

    var x = document.querySelector('[data-rf-dismiss]');
    if (x) x.addEventListener('click', function () {
      var bar = x.closest('.rf-beacon');
      if (!bar) return;
      bar.hidden = true;
      try { localStorage.setItem('rf-dismiss', bar.getAttribute('data-rf-sig')); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.RiftCore = { tick: tick, now: now, fmt: fmt };
})();
